<template>
  <!--渲染表单-->
  <el-form ref="form" class="process-form" label-position="top" :rules="rules" :model="_value">
    <div v-for="(item, index) in forms" :key="item.name + index">
      <!-- {{ item }} <br />
      {{ _value }} <br />
      {{ _value[item.id] }} -->
      <el-form-item :prop="item.id" :label="item.title">
        <form-design-render
            :forms="forms"
            :ref="`sub-item_${item.id}`"
            v-model="_value[item.id]"
            :labelName="item.title"
            mode="PC"
            :config="item"
            :value="_value[item.id]"
        />
      </el-form-item>
      <!-- <form-design-render
        ref="span-layout"
        v-else
        v-model="_value"
        mode="PC"
        :config="item"
        :value="_value[item.id]"
      /> -->
    </div>
  </el-form>
</template>

<script>
import FormDesignRender from '@/views/admin/layout/form/FormDesignRender'
import {commuter} from "@/api/design";
import moment from "moment/moment";

export default {
  name: 'FormRender',
  components: {FormDesignRender},
  props: {
    typeName:'',
    isAgainShenPi: {
      type: Boolean,
      default: false,
    },
    forms: {
      type: Array,
      default: () => {
        return []
      },
    },
    value: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      rules: {},
    }
  },
  created() {
    let that = this;
    console.log(this.forms, 'this.forms==')
    console.log(this.value, 'this.value==')
    if (that.isAgainShenPi) {
      console.log('是重新提交')
      for (let i = 0; i < that.forms.length; i++) {

        const e = that.forms[i]
        that.$store.state.formValue[e.id] = e.value
        // that._value[e.id] = e.value
        that.$set(that._value, e.id, e.value) // 使用 $set 确保响应式
      }

      that.loadFormConfig(that.forms)
    } else {
      console.log('不是重新提交')
      console.log(that.forms, '1234565555555')
      //判断是否包含请假两个字
      //判断开始时间赋值
      //判断结束时间赋值
      //判断当前
      if (that.typeName.includes('请假')) {
        //查询上下班时间进行赋值
        let params = {
          userId: that.$route.query.userId,
          platformId: that.$route.query.platformId,
          companyId: that.$route.query.EId,
          deptId: that.$route.query.deptId
        }
        commuter(params)
            .then((res) => {
              if (res.code == 200) {
                if (res.data.length > 0) {
                  let day = moment().format('YYYY-MM-DD');
                  let beginTime = day + ' ' + res.data[0].beginTime;//上班时间
                  let endTime = day + ' ' + res.data[0].endTime; // 下班时间
                  console.log(endTime)
                  console.log(beginTime)
                  that.forms.forEach(item => {
                    if (item.title == '开始时间') {
                      that.$store.state.formValue[item.id] = beginTime
                      that.$set(that._value, item.id, beginTime)
                    } else if (item.title == '结束时间') {
                      that.$store.state.formValue[item.id] = endTime
                      that.$set(that._value, item.id, endTime)
                    } else if (item.title == '时长（小时）') {
                      let hours=this.calculateLeaveHours(new Date(beginTime),new Date(endTime));
                      that.$store.state.formValue[item.id] = hours
                      that.$set(that._value, item.id, hours)
                      console.log(this.calculateLeaveHours(new Date(beginTime),new Date(endTime)),'小时');

                    }
                  });
                  // 给小时赋值


                }
              }/* else {
                wx.showToast({title: res.data.msg||'上下班时间获取失败',icon: 'none',duration: 1000})
              }*/
            });
      } else {
        that.loadFormConfig(that.forms)
      }
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val) // 确保触发 input 事件
      },
    },
  },
  watch: {
    _value: {
      deep: true,
      handler(newVal, OldVal) {
        // this.$emit("input", newVal);
        this.$store.commit('setFormValue', newVal)
      },
    },
  },
  methods: {
    calculateLeaveHours(startTime, endTime) {
      const workStartHour = 8;    // 上班小时 8
      const workStartMinute = 30; // 上班分钟 30
      const workEndHour = 18;     // 下班小时 18
      const workEndMinute = 0;    // 下班分钟 0
      const lunchStartHour = 12;  // 午休开始小时 12
      const lunchEndHour = 13;    // 午休结束小时 13
      const lunchEndMinute = 30;  // 午休结束分钟 30

      let totalLeaveHours = 0;
      let currentDate = new Date(startTime);

      // 处理跨天情况
      while (currentDate <= endTime) {
        const dayStart = new Date(currentDate);
        dayStart.setHours(0, 0, 0, 0);

        const dayEnd = new Date(currentDate);
        dayEnd.setHours(23, 59, 59, 999);

        // 当天的工作开始时间
        const workStart = new Date(dayStart);
        workStart.setHours(workStartHour, workStartMinute, 0, 0);

        // 当天的工作结束时间
        const workEnd = new Date(dayStart);
        workEnd.setHours(workEndHour, workEndMinute, 0, 0);

        // 当天的午休开始时间
        const lunchStart = new Date(dayStart);
        lunchStart.setHours(lunchStartHour, 0, 0, 0);

        // 当天的午休结束时间
        const lunchEnd = new Date(dayStart);
        lunchEnd.setHours(lunchEndHour, lunchEndMinute, 0, 0);

        // 计算当天的请假开始和结束时间
        const dayLeaveStart = new Date(Math.max(startTime, workStart));
        const dayLeaveEnd = new Date(Math.min(endTime, workEnd));

        // 如果请假时间段与工作时间有交集
        if (dayLeaveStart < dayLeaveEnd) {
          let leaveHours = (dayLeaveEnd - dayLeaveStart) / (1000 * 60 * 60);

          // 扣除午休时间
          const lunchOverlapStart = new Date(Math.max(dayLeaveStart, lunchStart));
          const lunchOverlapEnd = new Date(Math.min(dayLeaveEnd, lunchEnd));

          if (lunchOverlapStart < lunchOverlapEnd) {
            leaveHours -= (lunchOverlapEnd - lunchOverlapStart) / (1000 * 60 * 60);
          }

          totalLeaveHours += leaveHours;
        }

        // 移动到下一天
        currentDate.setDate(currentDate.getDate() + 1);
        currentDate.setHours(0, 0, 0, 0);
      }

      return totalLeaveHours;
    },

    input(val) {
      this._value = val
      console.log(this._value, 'PPval')
    }
    ,
    validate(call) {
      let success = true
      this.$refs.form.validate((valid) => {
        success = valid
        if (valid) {
          //校验成功再校验内部
          for (let i = 0; i < this.forms.length; i++) {
            if (this.forms[i].name === 'TableList') {
              let formRef = this.$refs[`sub-item_${this.forms[i].id}`]
              if (formRef && Array.isArray(formRef) && formRef.length > 0) {
                formRef[0].validate((subValid) => {
                  success = subValid
                })
                if (!success) {
                  break
                }
              }
            }
          }
        }
        call(success)
      })
    }
    ,
    loadFormConfig(forms) {
      forms.forEach((item) => {
        if (item.name === 'SpanLayout') {
          this.loadFormConfig(item.props.items)
        } else {
          this.$set(this._value, item.id, this.value[item.id] || null) // 确保默认值为 null 或其他适当值
          if (item.props.required) {
            this.$set(this.rules, item.id, [
              {
                type: item.valueType === 'Array' ? 'array' : undefined,
                required: true,
                message: `请填写${item.title}`,
                trigger: 'blur',
              },
            ])
          }
        }
      })
    }
    ,
  },
}
</script>

<style lang="less" scoped>
.process-form {
  /deep/ .el-form-item__label {
    padding: 0 0;
  }
}
</style>
